import {
  BookOpen,
  CalendarRange,
  GraduationCap,
  ListChecks,
  type LucideIcon,
  Settings,
  Users,
} from 'lucide-react'
import type { Product } from './me-types'

export interface NavItem {
  label: string
  to: string
  icon: LucideIcon
  matchPrefix?: string
  alleenBijRoosterUpload?: boolean
}

export const hoofdNavigatie: NavItem[] = [
  { label: 'Team', to: '/', icon: Users, matchPrefix: '/medewerker' },
  { label: 'Groepen', to: '/groepen', icon: GraduationCap, matchPrefix: '/groep' },
  { label: 'Vakken', to: '/vakken', icon: BookOpen, matchPrefix: '/vak' },
  { label: 'Taken', to: '/taken', icon: ListChecks },
  { label: 'Rooster', to: '/rooster', icon: CalendarRange, alleenBijRoosterUpload: true },
  { label: 'Instellingen', to: '/instellingen', icon: Settings },
]

export function zichtbareNavigatie(product: Product | undefined): NavItem[] {
  return hoofdNavigatie.filter((item) => !item.alleenBijRoosterUpload || product === 'upload')
}

export function isActief(item: NavItem, pad: string): boolean {
  if (item.matchPrefix && pad.startsWith(item.matchPrefix)) return true
  return pad === item.to
}
